'use client';

/**
 * SysObeyaKpiCohesionModulesCard — Procedural Patterns KPI tile.
 *
 * Slices `response.totals.modules_affected` from the system_obeya_view
 * cohesion call. Hero number is the count of distinct modules carrying
 * at least one flagged class — spread indicator.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_cohesion_modules"
 * @see klyde_edge/ui_config/labels/system_obeya.py — cohesion_kpi_modules_label
 */

import { Layers } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiCohesionModulesCard({ view_name = 'cohesion' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_cohesion_modules"
      label={L.cohesion_kpi_modules_label ?? ''}
      Icon={Layers}
      value={isLoading ? '…' : fmt(t.modules_affected)}
      queryKey={queryKey}
    />
  );
}
